import React from 'react'
import LoginForm from './LoginForm/LoginForm'
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';
import { useLocation } from 'react-router-dom';

const Login = () => {
    const location = useLocation();
    const contestToken = location?.state?.params;
    return (
        <Page>
            <SeoHelmet title="Login - Elite Partyz App" keywords="Party, Elite Party, Event, Event manager, Login" canonicalLink="/login" />
            <LoginForm token={contestToken} />
        </Page>
    )
}

export default Login
